import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AutoFixNormalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"auto_fix_normal"}/>
}
